import {IAction, IApInvokerArguments} from 'invoker-transport';

export class MetricSendModuleUrl implements IAction {
  public readonly type = '[metrics] module change';

  constructor(public payload: IApInvokerArguments[]) {
  }
}
